import _ from 'es-toolkit/compat';

import { EmploymentDataBenefitInfoFragment } from 'src/api';

export const hasBenefitMedicalFields = (
  benefit: Pick<
    EmploymentDataBenefitInfoFragment,
    'medicalInsuranceCarrier' | 'enrolledInMedical' | 'eligibleForMedical'
  >,
) =>
  !_.isNil(benefit.medicalInsuranceCarrier) ||
  !_.isNil(benefit.enrolledInMedical) ||
  !_.isNil(benefit.eligibleForMedical);

export const hasBenefitDentalFields = (
  benefit: Pick<
    EmploymentDataBenefitInfoFragment,
    'dentalInsuranceCarrier' | 'enrolledInDental' | 'eligibleForDental'
  >,
) =>
  !_.isNil(benefit.dentalInsuranceCarrier) ||
  !_.isNil(benefit.enrolledInDental) ||
  !_.isNil(benefit.eligibleForDental);
